
  <form [formGroup]="form">

    <p *ngIf="requiredCIEDiagnosis">
      <mat-form-field
        class="medium-width margin-right-small"
      >
        <input
          type="text"
          matInput
          placeholder="Diagnóstico C.I.E."
          formControlName="DiagnosisCIE"
          [matAutocomplete]="autDiagnosisCIE"
          required
        />
        <mat-autocomplete
          #autDiagnosisCIE="matAutocomplete"
          [displayWith]="filterCompleteautDiagnosisCIE.displayFn"
        >
          <mat-option
            *ngFor="let diagnosisCIE of filteredDiagnosesCIEOptions | async"
            [value]="diagnosisCIE"
          >
            {{ diagnosisCIE.Name }}
          </mat-option>
        </mat-autocomplete>

      </mat-form-field>
    </p>


    <mat-form-field
      *ngIf="isPreAdmission"
      class="card-inline margin-right-small"
    >
      <input
        matInput
        formControlName="AppointmentDate"
        #dateOrder
        [matDatepicker]="picker"
        placeholder="Fecha atención"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>


    <mat-form-field class="observation card-inline margin-right-small">
      <mat-label>Observaciones</mat-label>
      <input formControlName="Observation" type="text" matInput />
    </mat-form-field>
    <mat-form-field class="diagnostic card-inline margin-right-small">
      <mat-label>Diagnóstico</mat-label>
      <input formControlName="Diagnosis" type="text" matInput />
    </mat-form-field>
    <mat-form-field class="observation card-inline margin-right-small">
      <mat-label>Observaciones Paciente</mat-label>
      <input formControlName="ObservationPatient" type="text" matInput />
    </mat-form-field>


    <mat-checkbox formControlName="IsInternation" style="margin-left: 10px; margin-right: 10px;"> Internado </mat-checkbox>


    <button
    type="button"
    matTooltip="Preparación"
    (click)="openPreparationDialog()"
    mat-mini-fab
  >
    <mat-icon>flag</mat-icon>
  </button>


  </form>
